import { useCallback, useEffect, useState } from 'react'

type Props = {
  showMessageCondition: boolean
  timeout?: number | null
}
export const useAlert = ({ showMessageCondition, timeout }: Props) => {
  const [shown, setShown] = useState(false)

  useEffect(() => {
    setShown(showMessageCondition)
    let timeoutId = null
    if (!timeout) {
      return
    }
    timeoutId = setTimeout(() => {
      setShown(false)
    }, timeout)
    return () => {
      if (timeoutId) clearTimeout(timeoutId)
    }
  }, [showMessageCondition, timeout])

  const onClose = useCallback(() => setShown(false), [])

  return { shown, onClose }
}
